import { useToggler } from "./useToggler";

export const useShowPassword=()=> {

  const [showPassword, toggleShowPassword] = useToggler(false);

  const [showConPassword, toggleShowConPassword] = useToggler(false);

  return {
    showPassword,
    toggleShowPassword,
    showConPassword,
    toggleShowConPassword,
  };
};
